import React from 'react';
import { FluentProvider } from '@fluentui/react-components';
import PageLayout from './components/layout';
import useConfigStore from './store/config';
//import { useNavigate } from 'react-router-dom';

const App: React.FC = () => {
  const { theme } = useConfigStore(state => state.themeConfig);

  return (
    <FluentProvider theme={theme}>
      <PageLayout />
    </FluentProvider>
  );
};

export default App;
